import App from "App";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
// Material Dashboard 2 PRO React TS Context Provider
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "config/firebase.config";
import { AuthProvider } from "context/auth-context/auth.context";
import { MaterialUIControllerProvider } from "context/materialUI-context/materialUI.context";
import "i18n";

const root = createRoot(document.getElementById("root"));
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1 * 60 * 60 * 1000,
      cacheTime: 5 * 60 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <MaterialUIControllerProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </MaterialUIControllerProvider>
    </BrowserRouter>
  </QueryClientProvider>
);
